<template>
  <ele-page :multi-card="false">
    <div class="user-wrapper">
      <user-card :data="loginUser" @done="updateLoginUser" class="user-side" />
      <ele-card
        :header-style="{ padding: '0 24px' }"
        :body-style="{ padding: 0, minHeight: '462px' }"
        class="user-body"
      >
        <template #header>
          <el-button
            v-if="loginUser.category === 1"
            style="float: right; margin-top: 12px"
            @click="roleSignVisible = true"
            >角色签名</el-button
          >
          <ele-tabs
            type="plain"
            size="large"
            v-model="active"
            :items="[
              { name: 'info', label: '基本信息' },
              { name: 'account', label: '账号绑定' }
            ]"
          />
        </template>
        <user-form
          v-if="active === 'info'"
          :data="loginUser"
          @done="updateLoginUser"
        />
        <user-account
          v-if="active === 'account'"
          :data="loginUser"
          @done="updateLoginUser"
        />
      </ele-card>
    </div>
    <role-sign-modal v-if="roleSignVisible" v-model="roleSignVisible" />
  </ele-page>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue';
  import { useUserStore } from '@/store/modules/user';
  import type { TenantUser } from '@/api/bsl/tenant/user/model';
  import UserCard from './components/user-card.vue';
  import UserForm from './components/user-form.vue';
  import UserAccount from './components/user-account.vue';
  import RoleSignModal from './components/role-sign-modal.vue';

  defineOptions({ name: 'UserProfile' });

  const userStore = useUserStore();

  /** 标签页选中 */
  const active = ref('info');
  const roleSignVisible = ref(false);

  /** 登录用户信息 */
  const loginUser = computed(
    () => userStore.personalInfo ?? ({} as TenantUser)
  );

  /** 修改登录用户 */
  const updateLoginUser = (data: TenantUser) => {
    userStore.setInfo({ ...loginUser.value, ...data });
  };
</script>

<style lang="scss" scoped>
  .user-wrapper {
    display: flex;

    .user-side {
      width: 320px;
      margin: 0 16px 0 0;
      flex-shrink: 0;
    }

    .user-body {
      flex: 1;
    }
  }

  @media screen and (max-width: 928px) {
    .user-wrapper .user-side {
      width: 240px;
    }
  }

  @media screen and (max-width: 768px) {
    .user-wrapper {
      display: block;

      .user-side {
        width: auto;
        margin: 0 0 16px 0;
      }
    }
  }
</style>
